import {
  POST_REMINDEREMAIL_REQUEST,
  POST_REMINDEREMAIL_SUCCESS,
  POST_REMINDEREMAIL_FAILURE,
  GET_ADMINDOCUMENT_REQUEST,
  GET_ADMINDOCUMENT_SUCCESS,
  GET_ADMINDOCUMENT_FAILURE,
  PATCH_ADMINDOCUMENT_REQUEST,
  PATCH_ADMINDOCUMENT_SUCCESS,
  PATCH_ADMINDOCUMENT_FAILURE,
  UPDATE_ADMINDOCUMENT_INPUT
} from '../actions/AdminDocument'

let initialState = {
  doc: {},
  loading: false
}

export default (state = initialState, action) => {
  switch(action.type) {
    case POST_REMINDEREMAIL_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case POST_REMINDEREMAIL_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        reminder: 'success'
      })
    case POST_REMINDEREMAIL_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case GET_ADMINDOCUMENT_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case GET_ADMINDOCUMENT_SUCCESS:      
      return state = Object.assign({}, state, {
        loading: action.loading,
        doc: action.body.data[0]
      })
    case GET_ADMINDOCUMENT_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case PATCH_ADMINDOCUMENT_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case PATCH_ADMINDOCUMENT_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case PATCH_ADMINDOCUMENT_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case UPDATE_ADMINDOCUMENT_INPUT:
      var doc = state.doc
      doc[action.key] = action.value
      return state = Object.assign({}, state, {
        doc: doc
      })
    default:
      return state

  }

}



// WEBPACK FOOTER //
// ./src/reducers/AdminDocument.js